module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-next-circle-af5abe8de6da476acf0078f22575cded.svg";